import {AfterViewInit, Component, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {MatMenu} from '@angular/material/menu';
import {DropdownFilterGroup} from 'src/app/models/filter/dropdown-filter';
import { translate } from '@jsverse/transloco';

@Component({
    selector: 'app-dropdown-fliter',
    templateUrl: './dropdown-fliter.component.html',
    styleUrls: ['./dropdown-fliter.component.scss'],
    standalone: false
})
export class DropdownFliterComponent implements OnInit, AfterViewInit {

  @Input() inspirationLoungeFilter?: boolean;
  @Input() filterGroups: DropdownFilterGroup[];
  @Input() filterType?: string;
  @Output() changed = new EventEmitter();
  @ViewChild('menu', { static: true }) private menu: MatMenu;
  selectedCount: any;
  fieldFilterItem: string[];
  selectedItems: any;
  displayResetButton: boolean;
  displayClearAllButton: boolean;
  activeLink: string;

  filterData = [
    {
      tags: translate('INSPIRATION_LOUNGE.LOUNGE.ALL'),
    },
    {
      tags: translate('INSPIRATION_LOUNGE.LOUNGE.WEALTH'),
    },
    {
      tags: translate('INSPIRATION_LOUNGE.LOUNGE.CORPORATE'),
    },
    {
      tags: translate('INSPIRATION_LOUNGE.LOUNGE.BUSINESS'),
    },
    {
      tags: translate('INSPIRATION_LOUNGE.LOUNGE.RETAIL'),
    },
  ];


  constructor() {
  }

  ngOnInit(): void {
    this.activeLink = translate('INSPIRATION_LOUNGE.LOUNGE.ALL');
    this.resetFilter(true);
  }

  ngAfterViewInit(): void {
    this.menu.overlayPanelClass = 'mat-menu-panel';
  }

  selectFilterTypes(fieldFilterItem, $event: any): void {
    fieldFilterItem.selected = !fieldFilterItem.selected;
    this.countSelected();
    $event.stopPropagation();
  }

  countSelected(): void {
    this.displayResetButton = false;
    this.selectedCount = this.filterGroups.reduce((sum, filterGroup) => {
      sum += filterGroup.items.reduce((itemsSum, filterItem) => {
        if (filterItem.selected) {
          itemsSum += 1;
          this.displayResetButton = true;
        }
        return itemsSum;
      }, 0);
      return sum;
    }, 0);
  }

  resetFilter(skipApplyFilter?: boolean): void {
    this.activeLink = translate('INSPIRATION_LOUNGE.LOUNGE.ALL');
    this.filterGroups.forEach(filterGroup => filterGroup.items.forEach(item => item.selected = false));
    this.countSelected();
    this.displayClearAllButton = false;
    if (!skipApplyFilter) {
      this.applyFilter();
    }
  }

  applyFilterData(data): void {
    this.activeLink = data;
    if(data !== translate('INSPIRATION_LOUNGE.LOUNGE.ALL')) {
      const final = Object.assign({ tags: [data] });
      this.changed.emit(final);
    } else {
      this.resetFilter();
    }
  }

  applyFilter(): void {
    this.activeLink = translate('INSPIRATION_LOUNGE.LOUNGE.ALL');
    this.displayClearAllButton = false;
    this.selectedItems = [];
    const filter = this.filterGroups.reduce((acc, filterGroup) => {
      const selectedItemsForGroup = filterGroup.items.reduce((accItems, item) => {
        if (item.selected) {
          accItems.push(item.name);
          this.selectedItems.push(item);
          this.displayClearAllButton = true;
        }
        return accItems;
      }, []);
      if (selectedItemsForGroup.length > 0) {
        acc[filterGroup.name] = selectedItemsForGroup;
      }
      return acc;
    }, {});

    this.changed.emit(filter);
    this.countSelected();
  }

}
